import React from 'react';
import { Star, Quote } from 'lucide-react';

export const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "Emeka Okafor",
      role: "Patient",
      text: "I honestly didn’t know where to go before this. The team listened, explained things in a way I could understand, and didn’t make me feel rushed or judged. For the first time, I feel like I’m actually on top of my health."
    },
    {
      name: "Tinashe Chidyausiku",
      role: "Patient",
      text: "Booking was easy, follow-ups were clear, and I didn’t have to chase anyone for answers. Everything felt organized and professional, which gave me a lot of confidence in the care I was getting."
    },
    {
      name: "Thabo Mokoena",
      role: "Patient",
      text: "What stood out for me was how comfortable I felt asking questions. Nothing was brushed off. Knowing I have a team I can come back to makes a huge difference."
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20 space-y-4">
          <h2 className="text-4xl font-bold text-secondary">
            What Our <span className="text-primary">Patients Say</span>
          </h2>
          <p className="text-gray-500">Real stories from real patients. Discover why thousands trust us.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
           {testimonials.map((item, i) => (
             <div key={i} className="bg-gray-50/50 border border-gray-100 p-8 rounded-[2rem] hover:bg-white hover:shadow-xl hover:shadow-gray-200/50 transition-all duration-300 flex flex-col">
                <div className="mb-6 text-primary">
                    <Quote size={40} className="fill-current" />
                </div>
                
                <p className="text-gray-600 text-base leading-relaxed mb-6 flex-1 italic">"{item.text}"</p>
                
                <div className="flex items-center gap-4 mt-auto border-t border-gray-100 pt-6">
                    <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-primary font-bold text-sm tracking-wider">
                        {item.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div>
                        <h4 className="font-bold text-secondary text-sm">{item.name}</h4>
                        <div className="flex gap-0.5 mt-0.5">
                             {[1,2,3,4,5].map(star => <Star key={star} size={10} className="text-yellow-400 fill-yellow-400" />)}
                        </div>
                    </div>
                </div>
             </div>
           ))}
        </div>
      </div>
    </section>
  );
};